import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/Login'
import Layout from './components/Layout'
import AuthGuard from './components/AuthGuard'
import Dashboard from './pages/Dashboard'
import Products from './pages/Products'
import Categories from './pages/Categories'
import Orders from './pages/Orders'
import Users from './pages/Users'
import Employees from './pages/Employees'
import Customers from './pages/Customers'
import Inventory from './pages/Inventory'
import Warehouses from './pages/Warehouses'
import BOM from './pages/BOM'
import Production from './pages/Production'
import Purchase from './pages/Purchase'
import Suppliers from './pages/Suppliers'
import Delivery from './pages/Delivery'
import DeliveryDrivers from './pages/DeliveryDrivers'
import PickupPoints from './pages/PickupPoints'
import Ads from './pages/Ads'
import Receivables from './pages/Receivables'
import MemberLevels from './pages/MemberLevels'

import Finance from './pages/Finance'
import Reports from './pages/Reports'
import Settings from './pages/Settings'
import MonthlyBilling from './pages/MonthlyBilling'
import Invoices from './pages/Invoices'
import Statements from './pages/Statements'
import PurchaseInvoices from './pages/PurchaseInvoices'
import InvoiceApplications from './pages/finance/InvoiceApplications'
import EnterpriseClients from './pages/EnterpriseClients'
import DepartmentPosition from './pages/DepartmentPosition'
import ExpenseRecords from './pages/finance/ExpenseRecords'
import BankAccounts from './pages/finance/BankAccounts'
import Vouchers from './pages/finance/Vouchers'
import FinancialStatements from './pages/finance/FinancialStatements'
import Permissions from './pages/Permissions'
import Auxiliary from './pages/Auxiliary'
import Attendance from './pages/Attendance'
import Announcements from './pages/Announcements'
import LeaveRequests from './pages/LeaveRequests'
import CrmManagement from './pages/CrmManagement'
import EquipmentManagement from './pages/EquipmentManagement'
import PrivacyPolicy from './pages/PrivacyPolicy'
// Smart Tray
import SmartTrayOrders from './pages/SmartTrayOrders'
import SmartTrayPlates from './pages/SmartTrayPlates'
// Smart Tray - Ratings
import DailyMenus from './pages/DailyMenus'
import DishRatingsAnalysis from './pages/DishRatingsAnalysis'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/" element={<AuthGuard><Layout /></AuthGuard>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="categories" element={<Categories />} />
          <Route path="orders" element={<Orders />} />
          <Route path="users" element={<Users />} />
          <Route path="employees" element={<Employees />} />
          <Route path="customers" element={<Customers />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="warehouses" element={<Warehouses />} />
          <Route path="bom" element={<BOM />} />
          <Route path="production" element={<Production />} />
          <Route path="purchase" element={<Purchase />} />
          <Route path="suppliers" element={<Suppliers />} />
          <Route path="delivery" element={<Delivery />} />
          <Route path="delivery-drivers" element={<DeliveryDrivers />} />
          <Route path="pickup-points" element={<PickupPoints />} />
          <Route path="ads" element={<Ads />} />
          <Route path="receivables" element={<Receivables />} />
          <Route path="member-levels" element={<MemberLevels />} />

          <Route path="finance" element={<Finance />} />
          <Route path="finance/expense-records" element={<ExpenseRecords />} />
          <Route path="finance/bank-accounts" element={<BankAccounts />} />
          <Route path="finance/vouchers" element={<Vouchers />} />
          <Route path="finance/statements" element={<FinancialStatements />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<Settings />} />
          <Route path="monthly-billing" element={<MonthlyBilling />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="invoice-applications" element={<InvoiceApplications />} />
          <Route path="purchase-invoices" element={<PurchaseInvoices />} />
          <Route path="statements" element={<Statements />} />
          <Route path="enterprise-clients" element={<EnterpriseClients />} />
          <Route path="auxiliary" element={<Auxiliary />} />
          <Route path="department-position" element={<DepartmentPosition />} />
          <Route path="permissions" element={<Permissions />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="announcements" element={<Announcements />} />
          <Route path="leave-requests" element={<LeaveRequests />} />
          <Route path="crm" element={<CrmManagement />} />
          <Route path="equipment" element={<EquipmentManagement />} />
          <Route path="smart-tray-orders" element={<SmartTrayOrders />} />
          <Route path="smart-tray-plates" element={<SmartTrayPlates />} />
          <Route path="daily-menus" element={<DailyMenus />} />
          <Route path="dish-ratings" element={<DishRatingsAnalysis />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
